export default "__VITE_ASSET__BhzXrmqi__"